import React, { useEffect, useState } from 'react';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { Button } from '@mui/material';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
import axios from 'axios';
import Swal from "sweetalert2";
import { Base_Url, userlist, deleteuser } from '../../config/config';
import { toast } from 'react-toastify';
import '../../../src/css/custom-scrollbar.css'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDownload } from "react-icons/ai";
import { Search } from 'lucide-react';
import ViewAllCustomerModel from '../../component/b2c/models/ViewAllCustomerModel';

const ViewAllCustomer = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [totalCustomer, setTotalCustomers] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');


  useEffect(() => {
    fetchCustomers();
  }, [currentPage, limit]);

  const handleViewClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDownloadCSV = (customer) => {
    const csvContent = `data:text/csv;charset=utf-8,${[
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      [customer.id,
      customer.name,
      customer.email,
      customer.phone,
      customer.company_name,
      customer.company_type,
      customer.gst_number,
      customer.pancard_number,
      customer.aadhar_number
      ]
    ]
      .map((row) => row.join(","))
      .join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `customer_${customer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAllCustomers = () => {
    const csvContent = [
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      ...customers.map(customer => [
        customer.id,
        customer.name,
        customer.email,
        customer.phone,
        customer.company_name,
        customer.company_type,
        customer.gst_number,
        customer.pancard_number,
        customer.aadhar_number
      ])
    ]
      .map(row => row.join(","))
      .join("\n");

    if (customers.length === 0) {
      toast.error("No customers available to download");
      return;
    }

    const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csvContent}`);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "all_customers.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchCustomers = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => customer.role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;

        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal || 0);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getFilteredCustomers = () => {
    if (!searchTerm.trim()) {
      return customers;
    }

    const term = searchTerm.toLowerCase();
    return customers.filter(customer => {
      return (
        (customer.id?.toString().toLowerCase().includes(term)) ||
        (customer.name?.toLowerCase().includes(term)) ||
        (customer.phone?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayCustomers = getFilteredCustomers();

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(customers.length).keys()]);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };



  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            fetchCustomers();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}

        <div className="flex-1 flex flex-col overflow-hidden bg-gray-100 dark:bg-black p-2 md:p-2">
          <div className="flex flex-col flex-1 overflow-hidden bg-white dark:bg-black border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm p-3 md:p-4">

            {/* Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 shrink-0">
              <div className="flex items-center gap-2">
                <div className="p-1.5 rounded border border-gray-300 dark:border-gray-700">
                  <FaUser size={12} className="text-gray-600 dark:text-gray-400" />
                </div>
                <span className="text-[11px] font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  All Customers
                </span>
                <span className="text-[9px] text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-800 px-1.5 py-0.5 rounded-full">
                  {totalCustomer}
                </span>
              </div>
              {selectAll && (
                <button
                  onClick={handleDownloadAllCustomers}
                  className="text-[10px] bg-gray-800 dark:bg-white hover:opacity-80 text-white dark:text-black px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-all"
                >
                  <AiOutlineDownload size={11} />
                  Download All
                </button>
              )}
            </div>

            {/* Search */}
            <div className="relative w-full mt-2 shrink-0">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by Name / ID / Phone..."
                className="w-full pl-7 pr-3 py-1.5 text-[10px] rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-800 dark:text-white focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 transition-all"
              />
              <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 w-3.5 h-3.5" />
            </div>

            {/* Table */}
            <div className='flex-1 overflow-y-auto overflow-x-auto mt-2 border border-gray-200 dark:border-gray-800 rounded-lg'>
              <table className="min-w-full w-full table-fixed">
                <thead className="bg-slate-800 dark:bg-gray-900 text-white dark:text-gray-400 text-[9px] uppercase tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className='p-1.5 text-center w-8'>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className="accent-gray-800 dark:accent-white"
                      />
                    </th>
                    <th className="p-1.5 text-left w-12 font-medium">ID</th>
                    <th className="p-1.5 text-left font-medium">Name</th>
                    <th className="p-1.5 text-left font-medium hidden sm:table-cell">Email</th>
                    <th className="p-1.5 text-left w-24 font-medium">Phone</th>
                    <th className="p-1.5 text-center w-24 font-medium">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {displayCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="p-6 text-center text-[10px] text-gray-400 dark:text-gray-500">
                        No customers found
                      </td>
                    </tr>
                  ) : (
                    displayCustomers.map((customer, index) => (
                      <tr key={customer.id} className="hover:bg-gray-50 dark:hover:bg-gray-900/50 transition-colors">
                        <td className='p-1.5 text-center'>
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(index)}
                            onChange={() => handleRowSelect(index)}
                            className="accent-gray-800 dark:accent-white"
                          />
                        </td>
                        <td className="p-1.5 text-[10px] text-gray-500 dark:text-gray-400 font-mono">{customer.id}</td>
                        <td className="p-1.5 text-[10px] text-gray-800 dark:text-white font-medium truncate max-w-[100px]">{customer.name}</td>
                        <td className="p-1.5 text-[10px] text-gray-600 dark:text-gray-400 truncate max-w-[120px] hidden sm:table-cell">{customer.email}</td>
                        <td className="p-1.5 text-[10px] text-gray-600 dark:text-gray-400 font-mono">{customer.phone}</td>
                        <td className="p-1.5">
                          <div className="flex items-center justify-center gap-1">
                            <button
                              onClick={() => handleViewClick(customer)}
                              className="p-1 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                              title="View"
                            >
                              <IoMdEye size={12} />
                            </button>
                            <button
                              onClick={() => handleDelete(customer.id)}
                              className="p-1 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                              title="Delete"
                            >
                              <MdDelete size={12} />
                            </button>
                            <button
                              onClick={() => handleDownloadCSV(customer)}
                              className="p-1 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                              title="Download"
                            >
                              <AiOutlineDownload size={12} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className="mt-2 flex flex-col sm:flex-row justify-between items-center gap-2 shrink-0 pt-2 border-t border-gray-100 dark:border-gray-800">
              <span className="text-[9px] text-gray-500 dark:text-gray-400 font-medium">
                Total: <span className="text-gray-800 dark:text-white font-semibold">{totalCustomer}</span> customers
              </span>
              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className="border border-gray-300 dark:border-gray-700 rounded-lg p-1 text-[9px] bg-white dark:bg-black text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-500"
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                  <option value={30}>30</option>
                  <option value={totalCustomer}>All</option>
                </select>
                <Pagination
                  count={Math.ceil(totalCustomer / limit)}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: '#d1d5db',
                      color: '#374151',
                      '&.Mui-selected': {
                        backgroundColor: '#000',
                        color: '#fff',
                        borderColor: '#000',
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <ViewAllCustomerModel isopen={isPopupOpen} onClose={handleClose} customer={selectedCustomer} />
      </div>
    </div>
  );
};

export default ViewAllCustomer;